import { z } from "zod";
import { zodSchema } from "@/lib/utils/zod";

export const signUpSchema = z.object({
  phone: zodSchema.phone,
  password: zodSchema.password,
  code: z.string().regex(/^\d{6}$/, "Code must be a 6-digit number"),
  acceptedTerms: z.boolean().refine((value) => value === true, {
    message: "Please accept the Terms & Conditions to continue",
  }),
});
export type SignUpPayloadType = z.infer<typeof signUpSchema>;

export const signUpSocialSchema = z.object({
  phone: zodSchema.phone,
  token: z.string(),
  provider: z.string(),
});
export type SignUpSocialPayloadType = z.infer<typeof signUpSocialSchema>;

export const signInSchema = z.object({
  phone: zodSchema.phone,
  password: z.string(),
});
export type SignInPayloadType = z.infer<typeof signInSchema>;

export const newPasswordSchema = z
  .object({
    password: zodSchema.password,
    confirmPassword: zodSchema.password,
    isVerified: z.boolean().optional(),
  })
  .refine(
    (value) => {
      return value.password === value.confirmPassword;
    },
    { message: "Passwords must match", path: ["confirmPassword"] },
  );

export type NewPasswordPayloadType = z.infer<typeof newPasswordSchema>;
